import { NoSuspense } from "@/components/dev/DoNotSuspendHere.tsx";
import { MainLayoutContentLoadingSuspense } from "@/components/loading/Loading.tsx";
import { currentApiKeyAtom } from "@/modules/api/apikey.store.ts";
import { Toaster } from "@/modules/notifications/Toaster.tsx";
import WChatLoader from "@/modules/support/WChatProvider.tsx";
import { RemountOnPageUuid } from "@/utils/router/RemountOnPageUuid.tsx";
import NiceModal from "@ebay/nice-modal-react";
import { Outlet } from "@tanstack/react-router";
import { useAtomValue } from "jotai/react";
import React, { type ComponentType, type ReactNode, Suspense } from "react";
import { Fragment } from "react/jsx-runtime";

/** Root component inside the router. Contains various providers & utility wrappers. */
function BaseRouterRoot({
    Layout = React.Fragment,
    chatEnabled,
}: {
    /** Component to wrap the actual page content in. */
    Layout?: ComponentType<{ children: ReactNode }>;
    chatEnabled: boolean;
}) {
    const resetKey = useAtomValue(currentApiKeyAtom);
    // NB: NiceModal must be inside router so modals can access the router context
    return (
        // NB: Re-create ALL components when the API key changes since React Query has a bug where it does not
        // invalidate queries when the query client changes.
        <Fragment key={resetKey}>
            <NoSuspense>
                <NiceModal.Provider>
                    <Layout>
                        <MainLayoutContentLoadingSuspense>
                            <RemountOnPageUuid>
                                <Outlet />
                            </RemountOnPageUuid>
                        </MainLayoutContentLoadingSuspense>
                    </Layout>
                    <Toaster />
                    <Suspense>
                        <WChatLoader enabled={chatEnabled} />
                    </Suspense>
                </NiceModal.Provider>
            </NoSuspense>
        </Fragment>
    );
}

export default BaseRouterRoot;
